import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { variables } from '../utils';

interface SwitchProps {
  active: boolean;
  disabled?: boolean;
  toolTipText?: string;
  setActive?: (value: boolean) => void;
  onClick?: () => void;
}

const SwitchContainer = styled.button.attrs({
  type: 'button',
  className: 'br-pill flex items-center transition dib'
})`
  background: ${(p: { active: boolean }) => (p.active ? variables.green : variables.moonGray)};
  width: 34px;
  height: 22px;
  padding: 0 2px;
  justify-content: ${p => (p.active ? 'flex-end' : 'flex-start')};
  opacity: ${p => (p.disabled ? '.5' : 1)};
`;

const SwitchToggle = styled.span.attrs({
  className: 'switch-toggle bg-white br-pill transition'
})`
  border-radius: 100%;
  width: 18px;
  height: 18px;
`;

const Switch: React.FC<SwitchProps> = ({ disabled = false, active, toolTipText, ...rest }) => (
  <>
    <SwitchContainer
      active={active}
      disabled={disabled}
      data-tip={toolTipText}
      data-testid={`switch-${active ? 'active' : 'inactive'}`}
      {...rest}
    >
      <SwitchToggle />
    </SwitchContainer>
    <ReactTooltip className="tooltip" effect="solid" />
  </>
);

export default Switch;
